export default __webpack_public_path__ + "static/media/maxine_perspective.fd17cc78.jpg";